import React from 'react';

// Piezas del estilo collage de recortes (28/10/2026, ver ESTILO-COLLAGE.md en
// la carpeta de Marca). Las usan la landing y la página de prueba /probar.
// Tokens: negro #0b0b0c, crema #efe6d2 (títulos), papel #d9cfb6, tinta #14110d
// (texto sobre papel), verde #27AE60 (acento fuerte) y #8CF0B4 (acento claro,
// para letras sobre negro: el verde puro sobre negro no se lee).

// Tipografías del estilo (cargadas en index.css): Anton para títulos y números,
// Special Elite para rótulos y botones, Old Standard TT para texto sobre papel.
// Solo en las páginas públicas (landing y /probar): la app sigue con su tipografía.
export const FUENTE_TITULOS = "font-['Anton'] uppercase tracking-[0.02em] font-normal";
export const FUENTE_ROTULO = "font-['Special_Elite'] uppercase tracking-[0.12em]";
export const FUENTE_PAPEL = "font-['Old_Standard_TT',serif]";
export const FUENTE_TEXTO = "'Archivo', system-ui, sans-serif";

// Resaltador de título: letra clara con contorno grueso del verde fuerte y
// sombra negra (regla de legibilidad del estilo).
export const RESALTADO =
  'text-[#8CF0B4] [-webkit-text-stroke:4px_#27AE60] [paint-order:stroke_fill] [text-shadow:0_3px_0_rgba(0,0,0,0.85)]';

// Botón: fondo de acento, letra blanca con sombra, borde oscuro.
export const BTN_PRIMARY =
  "h-14 px-8 bg-[#27AE60] hover:bg-[#2FC06D] text-white font-['Special_Elite'] uppercase tracking-[0.1em] font-normal text-base rounded-full border-2 border-[#0b0b0c] [text-shadow:0_1px_2px_rgba(0,0,0,0.7)] shadow-[0_4px_0_#000,0_0_0_1px_rgba(140,240,180,0.3)] transition-all hover:scale-[1.02]";
export const BTN_SECUNDARIO =
  "h-14 px-7 bg-transparent border-2 border-[#efe6d2]/40 hover:border-[#efe6d2]/80 hover:bg-white/5 text-[#efe6d2] font-['Special_Elite'] uppercase tracking-[0.1em] font-normal text-sm rounded-full transition-colors";

// Papel rasgado: polígono de bordes irregulares en porcentajes (sirve a
// cualquier tamaño), generado con semilla fija para que no cambie entre cargas.
export function bordeRasgado(semilla, amp = 1.6, pasos = 22) {
  let x = semilla * 9301 + 49297;
  const rnd = () => {
    x = (x * 9301 + 49297) % 233280;
    return x / 233280;
  };
  const pt = (px, py) => `${px.toFixed(2)}% ${py.toFixed(2)}%`;
  const puntos = [];
  for (let i = 0; i <= pasos; i += 1) puntos.push(pt((i / pasos) * 100, rnd() * amp));
  for (let i = 1; i <= 5; i += 1) puntos.push(pt(100 - rnd() * amp * 0.5, (i / 6) * 100));
  for (let i = pasos; i >= 0; i -= 1) puntos.push(pt((i / pasos) * 100, 100 - rnd() * amp));
  for (let i = 5; i >= 1; i -= 1) puntos.push(pt(rnd() * amp * 0.5, (i / 6) * 100));
  return `polygon(${puntos.join(',')})`;
}

// Tarjeta de papel rasgado. El recorte (clip-path) va en el papel y la sombra
// proyectada en el contenedor, para que el recorte no la corte.
export function Papel({ semilla = 1, giro = 0, className = '', children, ...resto }) {
  return (
    <div
      className="relative h-full"
      style={{ transform: `rotate(${giro}deg)`, filter: 'drop-shadow(0 6px 0 rgba(0,0,0,0.55))' }}
      {...resto}
    >
      <div
        className={`${FUENTE_PAPEL} relative text-[#14110d] ${className}`}
        style={{
          backgroundColor: '#d9cfb6',
          backgroundImage: RUIDO_PAPEL,
          clipPath: bordeRasgado(semilla),
        }}
      >
        {children}
      </div>
    </div>
  );
}

export const RUIDO_PAPEL =
  'url("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%27120%27 height=%27120%27><filter id=%27n%27><feTurbulence type=%27fractalNoise%27 baseFrequency=%270.9%27 numOctaves=%272%27/></filter><rect width=%27120%27 height=%27120%27 filter=%27url(%23n)%27 opacity=%270.16%27/></svg>")';

// Grano sobre toda una sección (ruido fino, casi imperceptible).
export const GRANO =
  'url("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%27160%27 height=%27160%27><filter id=%27g%27><feTurbulence type=%27fractalNoise%27 baseFrequency=%270.8%27 numOctaves=%273%27 stitchTiles=%27stitch%27/></filter><rect width=%27160%27 height=%27160%27 filter=%27url(%23g)%27 opacity=%270.09%27/></svg>")';

// Mancha verde con trama de puntos, detrás de un conjunto de tarjetas.
export function Mancha({ className = '' }) {
  return (
    <div
      className={`absolute pointer-events-none ${className}`}
      style={{
        backgroundColor: '#27AE60',
        clipPath: bordeRasgado(7, 4.5, 34),
        backgroundImage:
          'radial-gradient(circle, rgba(0,0,0,0.55) 1.6px, transparent 2px), radial-gradient(circle at 50% 40%, transparent 55%, rgba(0,0,0,0.45) 100%)',
        backgroundSize: '9px 9px, 100% 100%',
      }}
      aria-hidden="true"
    />
  );
}
